import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center p-4" }
const _hoisted_2 = { class: "flex flex-row items-center" }
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = { class: "text-base font-regular text-gray-900 mr-4" }
const _hoisted_5 = { class: "text-base font-regular text-gray-500 mr-4" }
const _hoisted_6 = { class: "flex flex-row items-center" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs font-regular text-gray-500 mr-6"
}

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { BaseButton } from '@/lib/components/Button';
import { BaseIcon } from '@/lib/components/Icon';
import { formattedNHSNumber } from '@/lib/helpers/nhs-number.helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountListItem',
  props: {
  id: {
    type: String,
    default: null
  },
  label: {
    type: String,
    required: true
  },
  logoUri: {
    type: String,
    default: null
  },
  lastConnection: {
    type: String,
    default: null
  },
  readonly: {
    type: Boolean,
    default: false
  },
  showEditButton: {
    type: Boolean,
    default: true
  },
  showDeleteButton: {
    type: Boolean,
    default: true
  }
},
  emits: ["edit", "delete"],
  setup(__props) {

const props = __props;

dayjs.extend(relativeTime);

const { t } = useI18n();



const nhsNumberLabel = 'uhb-nhs-number';

const formattedLabel = computed<string>(() => {
  if (props.label === nhsNumberLabel) {
    return t('custom.uhb.patient.nhs-number') as string;
  }
  return props.label;
});
const formattedId = computed<string>(() => {
  if (props.id && props.label === nhsNumberLabel) {
    return formattedNHSNumber(props.id);
  }
  return props.id;
});

const formatDate = (date: string) => dayjs(date).fromNow();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.logoUri)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            alt: __props.label,
            src: __props.logoUri,
            class: "w-8 h-8 mr-4"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (__props.label === nhsNumberLabel)
        ? (_openBlock(), _createBlock(_unref(BaseIcon), {
            key: 1,
            class: "mr-2 flex items-center",
            name: "nhs-logo"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formattedLabel)), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formattedId)), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (__props.lastConnection)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('platform.patient.connected', {date: formatDate(__props.lastConnection)})), 1))
        : _createCommentVNode("", true),
      (!__props.readonly && __props.showEditButton)
        ? (_openBlock(), _createBlock(_unref(BaseButton), {
            key: 1,
            "data-cy": "edit-btn",
            class: "mr-4",
            color: "muted",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('edit')), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('platform.common.edit')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!__props.readonly && __props.showDeleteButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            "data-cy": "delete-btn",
            class: "focus:outline-none",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('delete')), ["prevent"]))
          }, [
            _createVNode(_unref(BaseIcon), {
              name: "delete",
              class: "text-gray-400 text-xl hover:text-gray-900 focus:text-gray-900"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})